import { createFileRoute } from '@tanstack/react-router';
import LocationsPage from '@/pages/setup/LocationsPage';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

export interface LocationsSearch {
  id?: string;
}

export const Route = createFileRoute('/_authenticated/setup/locations')({
  beforeLoad: () => requireSetupPageAccess('/setup/locations'),
  validateSearch: (raw: Record<string, unknown>): LocationsSearch => ({
    id: (raw.id as string) ?? undefined,
  }),
  component: LocationsPage,
});
